import React from 'react';

import { withRouter, useLocation } from 'react-router-dom';

import { Route, Switch } from 'react-router-dom';
import './App.css';
import myAccount from './components/myAccount';
import hoc from './components/hoc/protectedRoute'
import Terms from './components/docs/terms'
import RecurringTerms from './components/docs/recurringTerms'
import DocusignBridge from './components/ui/docuSignBridge';
import AddOnRenewal from './components/AddOnRenewal';
import AppHeader from './components/ui/AppHeader';

function App() {
  // The DocuSign bridge runs inside the signing iframe: no header there.
  const { pathname } = useLocation();
  const showHeader = pathname !== '/docusign-bridge';
  return (
    <div className="App">
      {showHeader && <AppHeader />}

      <Switch>
        {/* One route for both, so arriving at /renew (renewal reminder link)
            and moving on to / does not remount the page and close the dialog. */}
        <Route exact path={['/', '/renew']} component={hoc(myAccount)} />
        <Route exact path="/member/:memberId" component={hoc(myAccount)} />
        <Route exact path="/addon-renewal/:renewalId" component={hoc(AddOnRenewal)} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/recurring-payment-terms" component={RecurringTerms} />
        <Route exact path="/docusign-bridge" component={DocusignBridge} />
      </Switch>
    </div>
  );
}
export default withRouter(App);
